export default {"src":"/_next/static/media/Port-rafiki.5de6dbcc.svg","height":329,"width":446};